module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#/005toc#ch2"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("hree days later I was sitting in an air-conditioned office with Mum and Cole and a gray-faced man in a dark blue suit. The office was on the top floor of Bow Green police station, and the man in the dark blue suit was our Family Liaison Officer—Detective Robert Merton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was nine o’clock Friday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This wasn’t the first time we’d met Detective Merton. On Wednesday morning, after the police had informed us of Rachel’s death, he’d stayed at our house for a while and spent some time talking to Mum. Then, on Thursday, he’d come around again, and this time he’d talked to all of us. He’d told us what had happened to Rachel, and what was going to happen, and what might happen. He’d asked us questions. Told us how sorry he was. Tried to comfort us. Tried to help. He’d given us leaflets and brochures, talked to us about grief counseling and victim support and hundreds of other things that none of us wanted to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("Talk talk talk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s all it was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just talk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It didn’t mean anything. It was just Detective Merton doing his job. We knew that. But we also knew that his job didn’t belong in our house, and neither did he. He was a policeman. He wore a suit. He talked too much. We didn’t want any of that in our house. So when he’d phoned us on Thursday night to arrange another meeting, Mum had told him that this time we’d come to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s no need for that, Mary,” he’d said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll be there at nine,” Mum had told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now here we were, sitting at his cramped little desk, waiting to see what else he had to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked tired. His shoulders were hunched and his eyes were heavy, and I got the impression that he’d rather be somewhere else. As he removed a cardboard file from a drawer and placed it on the desk, I could see him struggling to find the right face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, Mary,” he said eventually, smiling somberly at Mum, “how have you been coping?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mum just stared at him. “My daughter’s dead. How do you think I’ve been coping?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, I didn’t mean…” His smile tightened with embarrassment. “I just meant with the media attention and everything.” He narrowed his eyes. “I hear there was a spot of trouble yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("Mum shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No?” Merton glanced at Cole, then turned back to Mum. “A TV reporter claims he was assaulted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He came into the yard.” Mum shrugged. “Cole kicked him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see.” Merton looked at Cole again. “It’s probably best to leave that kind of thing to us. I know you don’t want people nosing around, but the media can be very useful at times. It’s best not to alienate them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cole said nothing, just stared impassively at the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton continued to look at him. “If anything becomes too intrusive, all you have to do is let me know.” He smiled. “I can’t promise miracles—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just tell them to keep away from us,” Cole said quietly. “If anyone else comes into the yard I’ll kick the shit out of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton’s smile faded. “Look, I’ll do my best to protect your family’s privacy, Cole, but I’d strongly advise you not to take any further action—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m serious—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So am I.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton looked at him, his face all flustered. Cole stared back. Merton opened his mouth and started to say something, but when he saw the look in Cole’s eyes he suddenly changed his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t blame him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _vm._v("Since Rachel’s death, Cole had sunk so far inside himself that it was hard to tell if he felt anything at all. There was just nothing there. No sadness, no grief, no hate, no anger. It was frightening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m worried about him,” Mum had said to me earlier that morning. “Have you seen his eyes? They’ve got something missing. That’s how your father used to look just before a fight, like he didn’t care if he lived or died.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew she was right. Merton knew it, too. That’s why he was pretending to study the file on his desk—he was trying to forget the look in Cole’s eyes. He wasn’t having much luck, though. It’s not the kind of look you can forget in a hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, well,” he said after a while, looking up at Mum. “It was very good of you to come all this way to see me, Mary, but you really shouldn’t have put yourselves out. As I told you before, I’m perfectly happy to visit you at home whenever you want. That’s what I’m here for. Anytime you need anything, day or night—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re fine,” Mum told him. “We’d rather be left on our own, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.” Merton smiled. “But if you change your mind—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton looked at Mum for a moment, then nodded his head and continued. “Right, well, I think I told you on the phone that your brother-in-law has now formally "), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _vm._v("identified Rachel’s body.” He paused for a moment, pretending to think about it. “He drove down to Plymouth yesterday, I believe?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wednesday,” Mum said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Joe went down there on Wednesday night. He got back yesterday morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you spoken to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mum just nodded again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton looked at her, waiting for her to say something else. When she didn’t, he turned his attention to the file on his desk and started shuffling through pieces of paper. “Yes, well,” he said, “I just thought we’d go over one or two things again, if that’s all right with you.” He looked up. “I know it’s difficult, but it’s vital in these early stages to gather as much information as possible. We also think it’s best to keep you informed about how the investigation is proceeding.” He glanced at me. “If Ruben here doesn’t want to stay, I’m sure we can—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m all right,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave me a patronizing smile. I stared back at him. He turned back to Mum with a questioning look, as if to say—What do "), _c('i', [_vm._v("you")]), _vm._v(" think?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ruben knows what happened,” she told him. “He’s already heard the worst of it. If there’s anything else to know, he needs to know it as much as anyone else. He’s fourteen. He’s not a child.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("“Of course,” said Merton, lowering his eyes to the file. I could tell he wasn’t happy, but there wasn’t much he could do about it. He removed some papers from the file, studied them for a moment, then put on a pair of reading glasses and started going over the whole thing again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’d already heard it about a dozen times. The same questions, the same answers:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("Yes, Rachel was nineteen years old.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, she was unemployed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, she lived with her family at Ford & Sons Auto Parts, Canleigh Street, London E3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, she didn’t have any enemies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, she was single.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, she didn’t have a boyfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("And then the same simple facts:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("On Friday, May 14, Rachel had taken a train to Plymouth to visit an old school friend named Abbie Gorman. Abbie lives with her husband in the small village of Lychcombe on Dartmoor. On the night of Tuesday, May 18, Rachel set out from Lychcombe on her way back to London. She never arrived. Her body was found the following morning in a remote moorland field about a mile from the village. She’d been raped and battered and strangled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Simple.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Facts.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("I glanced at Mum. She wasn’t crying—she’d done all her crying—but her face looked a thousand years old. She was exhausted. She hadn’t slept in three days. Her skin was dry and pale. Her soft black hair had lost its shine. Her eyes were haunted and still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cole looked at me. His dark eyes were almost black. I didn’t know what he was thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton said, “So far, the investigation is going as well as can be expected, but there’s still a lot of work to be done. Forensics are still very confident of finding something, and the investigation team are still working their way through dozens of witness statements. We’re doing everything possible to find out what happened to Rachel. But we have to follow procedures, and I’m afraid these things take time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much time?” Mum asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton pursed his lips. “That’s difficult to say…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where is she now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rachel—where is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton hesitated. “Her body…your daughter’s body is in the care of the Coroner’s Office in Plymouth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s in an "), _c('i', [_vm._v("office")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no…” Merton shook his head. “She’ll be in a mortuary. The Coroner’s Office deals with the inquest and the postmortem—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("“When can we get her back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mum leaned forward in her chair. “I want my daughter back, Mr. Merton. She’s been dead three days. I want to bring her back home and bury her. She shouldn’t have to be on her own in a place she doesn’t know. She’s been through enough already. She doesn’t deserve any more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton didn’t know what to say for a moment. He looked at Mum, glanced at Cole, then turned back to Mum again. “I understand your concerns, Mary, but I’m afraid it’s not as simple as that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, there are all kinds of practical matters to consider.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forensic tests, for a start. Some of them are highly complex and time-consuming. I realize it’s a distressing thing to think about, but we can learn a lot from Rachel’s body. It can tell us a lot about what happened. And once we know what happened, we’ve got a far better chance of finding out who did it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("The Dead Man did it")]), _vm._v(", I thought. "), _c('i', [_vm._v("It was the Dead Man. You’re never going to find him now.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To put it simply,” Merton continued, “the coroner will only release your daughter’s body when he’s satisfied that it’s no longer required for examination. Unfortunately, this can take some time, especially if no one’s been charged "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("with her murder. Once someone has been charged, their lawyers are entitled to arrange a second and independent postmortem. Once this has been done, the coroner will usually release the body. However, if no one’s been charged, but the police expect to charge someone in the foreseeable future, then the coroner will retain the body in the expectation that a second postmortem will be required.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton looked at Mum again. “I’m sorry it’s all so complicated, but I’m afraid it might be three or four months before your daughter’s body can be released.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if they find the killer?” asked Cole. “How long will it take then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton looked at him. “Again, it’s hard to say…but, yes, the sooner we find out who did it, the sooner we can release Rachel’s body.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cole said nothing, just nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton looked down at his papers for a while, then he took off his reading glasses and rubbed his eyes. “I know this is a terrible time for all of you,” he said, “but I can assure you that we’ll do everything possible to help you cope with your loss.” He paused for a moment, then went on. “If you have any problems in terms of your beliefs…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our what?” said Mum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Beliefs…customs…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton looked down at his papers again. “Your "), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("husband,” he said hesitantly, squinting at the pages. “Barry John…?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Baby-John,” Mum corrected him. “What about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s a Traveler, I believe.” Merton looked embarrassed. “Is that right—Traveler? Or is it Roma…Romany?” He smiled awkwardly. “I’m sorry, I don’t know what you people prefer—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s a gypsy,” Mum said simply. “What’s that got to do with anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I just thought…I mean, I’m aware that certain cultures have certain beliefs regarding funeral arrangements…” His voice trailed off and he looked at Mum, hoping she’d help him out. But he was wasting his time. She just stared at him. He shrugged uncomfortably. “I’m sorry, I don’t mean to cause any offense or anything. I’m just trying to understand why you want to bury your daughter so quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mum stared at him. “My husband’s a gypsy—I’m not. He’s in prison, as I’m sure you’re aware—I’m not. I want to bury my daughter because she’s dead, that’s all. She’s my daughter. She’s dead. I want to bring her back home and put her to rest. Is that so hard to understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, of course…I’m sorry—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if you’re "), _c('i', [_vm._v("that")]), _vm._v(" concerned about my husband,” she added, “why don’t you let him out on compassionate leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m afraid that’s in the hands of the prison authorities. If they think he poses a risk—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("“John’s no risk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton raised his eyebrows. “He’s serving a sentence for manslaughter, Mary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cole suddenly stood up. “Come on, Mum, let’s go. We don’t have to listen to this shit. I told you it was a waste of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Merton couldn’t help glaring at him. “We’re doing our best, Cole. We’re trying to find out who killed your sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cole looked down at him and spoke quietly. “You just don’t get it, do you? We don’t "), _c('i', [_vm._v("care")]), _vm._v(" who killed her. She’s dead. It doesn’t matter who did it or why they did it or how she died—she’s dead. Dead is dead. Nothing can change that. Nothing. All we want to do is bury her. That’s all we "), _c('i', [_vm._v("can")]), _vm._v(" do—bring her home and get on with our lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("Cole didn’t say anything on the way back, and Mum was too tired and empty to talk. So, as we walked the familiar backstreets through the hazy May sunshine, I just soaked up the silence and let my mind wander around the things I knew and the things I didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew the Dead Man had killed Rachel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t know who he was, or why he’d done it. But I knew he was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t know why he was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And I didn’t know what it meant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hadn’t told any of this to Cole or Mum yet, and I didn’t know when—or if—I was going to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t know what that meant, either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("But the biggest thing I didn’t know was how I felt about Rachel. After that night in the back of the Mercedes, when all I’d felt was blackness and nothing, my head and heart had been invaded with all the feelings in the world, some of which I’d never felt before. I was sick and empty and full of lies. I wanted to hate someone, but I didn’t know who. I was nowhere and everywhere. I was lost.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("When we got home, Cole went straight up to his room without saying a word. I followed Mum into the kitchen and made us some tea, then we sat down together at the table and listened to the muffled sounds coming from Cole’s room. Measured footsteps, drawers opening, drawers closing…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s going to Dartmoor, isn’t he?” I said to Mum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think that’s a good idea?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know, love. I’m not sure it matters what I think. You know what he’s like when he sets his mind on something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you think he’s planning to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find out who did it, I expect.” She looked at me. “He wants to find out who killed Rachel so we can bring her back home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure that’s all he wants?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked around the kitchen. It’s always been my "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("favorite room. It’s big and old and warm and there are lots of things to look at. Old photographs and postcards, pictures we’d drawn when we were kids, china ducks, flowery plates, vases and jugs, trailing plants in a large bay window…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I watched the sunlight streaming in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wished it wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want me to go with him?” I said to Mum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He won’t want you to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiled at me. “I’d feel better if you did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about you?” I asked her. “Will you be all right here on your own?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded. “Business is pretty quiet just now. Uncle Joe won’t mind staying over for a couple of days to keep an eye on things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t mean the business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.” She touched my arm. “I’ll be all right. It’ll probably do me good to be on my own for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded again. “Just keep in touch—OK? And keep your eye on Cole. Try not to let him do anything stupid.” She looked at me. “He listens to you, Ruben. He trusts you. I know he doesn’t show it, but he does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll look after him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And see if you can get him to agree to you going. It’ll make things a whole lot easier for both of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v("I knew he wouldn’t agree, but I gave it a shot anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("When I went into his room he was sitting on his bed smoking a cigarette. He was dressed in a T-shirt and jeans, and his jacket was draped over a small leather backpack on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glanced at his backpack. “Going somewhere?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The answer’s no,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you can’t come with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went over and sat down beside him. He tapped ash from his cigarette into an ashtray on the bedside table. I smiled at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s no good looking at me like that,” he said. “I’m not going to change my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I haven’t even asked you anything yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“D’you think you’re the only one who can read people’s minds?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t read minds,” I said. “You can’t even read a newspaper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He glanced at me, then went back to smoking his cigarette. I looked at his face. I like looking at his face. It’s a good face to look at—seventeen years old, dark-eyed and steady and pure. It’s the kind of face that does what it says. The face of a devil’s angel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v("“You need me,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you’re going to Dartmoor, you need me to look after you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mum’s the one who needs looking after.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So why are you going, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to get Rachel back. That’s my way of looking after Mum. Your way is staying here.” He looked at me. “I can’t talk to her, Rube. I don’t know what to say. I just need to "), _c('i', [_vm._v("do")]), _vm._v(" something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A flicker of emotion showed briefly in his face, and just for a moment I started to feel something, but before I could tell what it was he’d regained control of himself and blanked it out. He was good at blanking things out. I watched him as he put out his cigarette and got up from the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you going to do it?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find out what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know yet…I’ll think of something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you going to stay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrugged. “I’ll find somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you going to get there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Train.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When are you going?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whenever I’m ready. Any more questions?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah—why don’t you want me to come with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve already told you—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("“I’m not stupid, Cole. I know when you’re lying. You know as well as I do that Mum doesn’t need anyone to stay with her. What’s the "), _c('i', [_vm._v("real")]), _vm._v(" reason you don’t want me to come?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He went over to a table by the window, grabbed a couple of things, and shoved them into his backpack. He fiddled around with the bag for a while—tying it, untying it, tying it again—then he stared at the floor, and then finally he turned around and looked at me. I don’t know if he was going to say anything or not, but before he had a chance to speak, the phone rang downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We both turned to the door and listened hard. The ringing stopped and we heard the faint murmur of Mum’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that Dad she’s talking to?” asked Cole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounds like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to speak to him before I go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He picked up his backpack and headed out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See you later,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He walked out without looking back.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("I wasn’t worried. I knew what he was going to do.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_vm._v("While Cole was speaking to Dad on the phone, I checked out a few things on the Internet and quickly packed some "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("clothes into a bag. Then I stood by the bedroom window and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a while, Cole came out of the house and headed across the yard toward a pile of old cars. He was wearing his jacket and carrying his backpack. He took a key out of his pocket and opened up the trunk of a burned-out Volvo that was stacked at the bottom of the pile. After a quick look over his shoulder, he stooped down and rummaged around in the farthest corner of the trunk. It didn’t take him long to find what he was looking for. He put something in his bag, something else in his pocket, then he straightened up and shut the trunk and walked out of the yard and away down the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I waited until he was out of sight, then I picked up my bag and went downstairs into the kitchen. Mum was waiting for me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here,” she said, passing me about £200 from her purse. “That’s all the cash I’ve got at the moment. Is that going to be enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cole’s got plenty,” I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good. Do you know what train he’s catching?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t say, but the next one to Plymouth leaves at eleven thirty-five, so I’m guessing he’ll be on that.” I folded the cash into my pocket. “How’s Dad?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s OK. He sends his love.” She looked at the clock. It was ten forty-five. She came over and gave me a hug. “You’d better get going.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v("“Are you sure you’re going to be all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She ruffled my hair. “Don’t worry about me. Just try to keep Cole out of too much trouble. And make sure you both come back in one piece—OK?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll do my best.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sun was still shining as I left the yard and headed down the street. I wondered what the weather would be like on Dartmoor. I wondered what "), _c('i', [_vm._v("anything")]), _vm._v(" would be like on Dartmoor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A black cab was dropping someone off at the end of the road. I waited for the passenger to get out, then I got in the back and asked the driver to take me to Paddington Station.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25715ca0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007-chapter2.vue
// module id = 72
// module chunks = 0